import DownloadReportPopupDesk, { DownloadEnumReportType, } from "../../../../components/generic/DownloadReports/DownloadReportPopupDesk";
import React, { useContext, useEffect, useState } from "react";
import PopupFail from "../../../../components/Reports/HoldingReports/SMCaseLoadPopup/SmcasePopupFail";
import PopupLoader from "../../../../components/Reports/HoldingReports/SMCaseLoadPopup/SmcasePopupLoader";
import SuccessPopup from "../../../../components/Reports/HoldingReports/SMCaseLoadPopup/SmcasePopupSuccess";
import DeviceContext from "../../../../utils/indentifyDevice";
import EdModal from "../../../../components/generic/edModal";
import { ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import di from "../di/servicelocator";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import DownloadDropDown from "../DownloadDropDown";
import { DownlodTaxReportType } from "@domains/aggregates/interfaces/Reports/iTaxReport";
import { getLoginSourceURL } from "@frameworks/web/utils/Navigate";
import FamilyTaggingMain from "@frameworks/web/components/Reports/FamilyTagging/FamilyTaggingReport/FamilyTaggingMain";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { WebConfigContext } from "@frameworks/web/utils/webConfig";
import { ELoginSource } from "@domains/entities/interfaces/iUserDetails";
import { LoginSource } from "@domains/utils/emtReportCallback";
import PANPassword from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/PANPassword";
const ShowGains = (props) => {
    const navigate = useNavigate();
    const { loginOrigin } = useParams();
    const sales_native_app = JSON.parse(localStorage.getItem("sales_native_app"));
    const webConfig = useContext(WebConfigContext);
    const [showLoader, setShowLoader] = React.useState(false);
    const [downloadSuccess, setDownloadSuccess] = React.useState(false);
    const [downloadFail, setDownloadFail] = React.useState(false);
    const [operation, setOperation] = useState();
    const [showBand, setShowBand] = React.useState(true);
    const [finYear, setFinYear] = React.useState(props.finYear ? props.finYear : new Date().getFullYear());
    const [endDate, setEndDate] = React.useState(new Date());
    const [startDate, setStartDate] = React.useState(new Date(finYear, new Date().getMonth(), 1));
    const [downloadTypeOfTaxReport, setDownloadTypeOfTaxReport] = React.useState("");
    const [usetaxDPURL, setUsetaxDPURL] = React.useState(false);
    const [showTableDropdown, setshowTableDropdown] = React.useState(false);
    const [openFamilyDrop, setOpenFamilyDrop] = React.useState(false);
    const dpIds = useSelector((state) => state.holdingReport.dpTransactionEntity.dpIds);
    const [selectedDpId, setSelectedDpId] = useState(null);
    const [elssPopUp, setElssPopUp] = useState(false);
    const downloadRef = React.useRef(null);
    const downloadStatus = useSelector((state) => state.taxReport.downloadStatus);
    const isImpersonated = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.isImpersonated; });
    const lgnSrc = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.lgnSrc; });
    const isClientLogin = loginOrigin !== LoginSource.SALES &&
        !sales_native_app &&
        !isImpersonated &&
        lgnSrc !== ELoginSource.NESTTRADER;
    const goBack = () => {
        const destination = ".." +
            getLoginSourceURL(loginOrigin) +
            "?reportName=Tax" +
            "&fromDate=" +
            moment(props.startDate).format("yyyy-MM-DD") +
            "&toDate=" +
            moment(props.endDate).format("yyyy-MM-DD");
        navigate(destination, { replace: true });
        setOperation("");
    };
    const initiateELSSDownload = () => {
        let download = {
            fromDate: moment(props.startDate).format("yyyy-MM-DD"),
            toDate: moment(props.endDate).format("yyyy-MM-DD"),
            reportType: ReportType.PDF,
            urlParts: "/elss",
        };
        if (props.accCode)
            download.accodes = props.accCode;
        if (webConfig.passwordProtectedDownloadReports)
            download.isPwdProtected = true;
        di.taxReport.downloadAndSendReportTax(null, download);
        setshowTableDropdown(false);
        setDownloadTypeOfTaxReport(null);
        setShowLoader(true);
        setOperation("download");
    };
    const [openCalendar, setOpenCalendar] = React.useState(false);
    const TAXDownloadDropDown = [
        {
            title: "Tax Report",
            value: DownlodTaxReportType.TaxReport,
            onClick: () => {
                props.setOpenPopup(true);
                setshowTableDropdown(false);
                props === null || props === void 0 ? void 0 : props.setIsTaxHarvesting(false);
                setDownloadTypeOfTaxReport(null);
            },
        },
        {
            title: "80C/ELSS",
            value: DownlodTaxReportType["80C"],
            onClick: () => {
                setElssPopUp(true);
                props === null || props === void 0 ? void 0 : props.setIsTaxHarvesting(false);
                setshowTableDropdown(false);
            },
        },
        {
            title: "TCS TDS",
            value: DownlodTaxReportType.TCSTDS,
            onClick: () => {
                setDownloadTypeOfTaxReport("/tcstds");
                props.setOpenPopup(true);
                props === null || props === void 0 ? void 0 : props.setIsTaxHarvesting(false);
                setshowTableDropdown(false);
            },
        },
        {
            title: "Delayed payment charges",
            value: DownlodTaxReportType.DPCash,
            onClick: () => {
                setDownloadTypeOfTaxReport("/cash");
                setUsetaxDPURL(true);
                props.setOpenPopup(true);
                props === null || props === void 0 ? void 0 : props.setIsTaxHarvesting(false);
                setshowTableDropdown(false);
            },
        },
        {
            title: "DP Bills",
            value: DownlodTaxReportType.DPBill,
            onClick: () => {
                var _a;
                setDownloadTypeOfTaxReport("/bills");
                setUsetaxDPURL(true);
                props.setOpenPopup(true);
                props === null || props === void 0 ? void 0 : props.setIsTaxHarvesting(false);
                setshowTableDropdown(false);
                setSelectedDpId((_a = dpIds[0]) === null || _a === void 0 ? void 0 : _a.value);
            },
        },
    ];
    React.useEffect(() => {
        if (!props.openPopUp) {
            if (props.finYear)
                setFinYear(props.finYear);
        }
    }, [props.openPopUp]);
    useEffect(() => {
        function handleClickOutside(event) {
            if (downloadRef.current && !downloadRef.current.contains(event.target))
                setshowTableDropdown(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [downloadRef]);
    useEffect(() => {
        if (elssPopUp &&
            downloadStatus &&
            (downloadStatus === null || downloadStatus === void 0 ? void 0 : downloadStatus.isOpen) !== null &&
            showLoader) {
            setShowLoader(false);
            if ((downloadStatus === null || downloadStatus === void 0 ? void 0 : downloadStatus.isOpen) === true)
                setDownloadSuccess(true);
            else
                setDownloadFail(true);
        }
    }, [downloadStatus === null || downloadStatus === void 0 ? void 0 : downloadStatus.isOpen]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "show-gains-container" },
            React.createElement("div", { className: "tax-download-container w-100 d-flex justify-content-end align-items-center gap-10" },
                React.createElement("div", { className: "download-btn downloads" },
                    React.createElement("button", { className: "btn btn-outline-primary downloads ", onClick: () => {
                            if (!(
                            // props?.taxReportError?.isOpen ||
                            // props?.emptyValidation?.icon ===
                            //   EmptyValidation[EmptyIcon.EMPTY][ReportsEnum.TAX].icon ||
                            props.shimmer))
                                setshowTableDropdown(!showTableDropdown);
                        } },
                        React.createElement("i", { className: "edel-icon-download " }),
                        "Download"),
                    showTableDropdown && (React.createElement("div", { ref: downloadRef },
                        React.createElement(DownloadDropDown, { setShowTableDropdown: setshowTableDropdown, bodyList: TAXDownloadDropDown, parentClassName: "position-relative" })))),
                React.createElement(FamilyTaggingMain, null))),
        React.createElement(React.Fragment, null, DeviceContext().isDesktop && (React.createElement(React.Fragment, null,
            React.createElement(EdModal, { show: props.openPopUp, setShow: (openPop) => props.setOpenPopup(openPop), size: "modal-md modal-dialog-centered", icon: "edel-icon-download1", modalTitle: "modalDPTitle", title: `${props.isTaxHarvesting
                    ? "Download Tax Harvest Report"
                    : "Download Tax Transactions"}`, showFooter: false },
                React.createElement("div", { className: "downloadHoldingDesk taxreport" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-12 col-lg-12 downloadHoldingDesk-form" },
                            React.createElement(DownloadReportPopupDesk, { isTaxHarvesting: props.isTaxHarvesting, showdate: props.isTaxHarvesting && true, startDate: props.startDate, endDate: props.endDate, withEndDate: true, openCalendar: openCalendar, setOpenCalendar: setOpenCalendar, showBand: showBand, setShowBand: setShowBand, years: props.years, setEndDate: setEndDate, setStartDate: setStartDate, resetFields: props.openPopUp, showLoader: showLoader, setShowLoader: setShowLoader, setDownloadSuccess: setDownloadSuccess, setDownloadFail: setDownloadFail, setOperation: setOperation, submit: (email, download) => {
                                    di.taxReport.downloadAndSendReportTax(email, download);
                                    props.setOpenPopup(false);
                                    setDownloadTypeOfTaxReport("");
                                    setUsetaxDPURL(false);
                                }, reportType: DownloadEnumReportType.TAX, PDF_or_Excel: props.isTaxHarvesting
                                    ? ReportType.PDF
                                    : ReportType.EXCEL, urlParts: downloadTypeOfTaxReport, usetaxDPURL: usetaxDPURL, dpIds: dpIds, showDPIDDropDown: downloadTypeOfTaxReport === "/bills" ? true : false, setDpId: (event) => {
                                    setSelectedDpId(event.target.value);
                                }, selectedDpId: selectedDpId, accodes: props.accCode }))))),
            showLoader && (React.createElement("div", { className: "modalBackground" },
                React.createElement("div", { className: "modalContainer tax-report-loader" },
                    React.createElement(PopupLoader, { Title: props.isTaxHarvesting ? "Tax Harvesting" : "Tax", isDownload: true, messageReactNode: React.createElement(React.Fragment, null,
                            React.createElement("label", { className: "update-message" }, "Your request is being processed")) })))),
            downloadSuccess && (React.createElement("div", { className: "modalBackground" },
                React.createElement("div", { className: "modalContainer tax-report-succcess" },
                    React.createElement(SuccessPopup, { setDownloadSuccess: setDownloadSuccess, Title: props.isTaxHarvesting ? "Tax Harvesting" : "Tax", operation: operation, pageName: "Tax", isDownload: true, sendBack: true, goBack: goBack, messageReactNode: React.createElement(React.Fragment, null,
                            React.createElement("label", { className: "update-message" }, "Your request was successfully processed.")) })))),
            downloadFail && (React.createElement("div", { className: "modalBackground" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(PopupFail, { setDownloadFail: setDownloadFail, Title: props.isTaxHarvesting ? "Tax Harvesting" : "Tax", operation: operation, pageName: "Tax", isDownload: true, sendBack: true, goBack: goBack })))),
            elssPopUp && (React.createElement(EdModal, { show: elssPopUp, setShow: setElssPopUp, showFooter: false, modalTitle: "", title: "Download ELSS", size: "modal-dialog-centered" },
                !isClientLogin && React.createElement(PANPassword, null),
                React.createElement("div", { className: "d-flex justify-content-center align-items-center mt-3" },
                    React.createElement(EdButton, { btnTyp: "midnight-blue-border", onClick: initiateELSSDownload, type: "submit", value: "Download", className: "py-2 px-3" }, "Download")))))))));
};
export default ShowGains;
